import { type FC } from "react";

import LogoSvg from "~/assets/icons/logo.svg?react";

import * as Styled from "./LinearChart.styles";

const WAVE_POINTS = 48;

const WAVE_PATH = Array.from({ length: WAVE_POINTS + 1 }, (_, index) => {
  const x = (index / WAVE_POINTS) * 100;
  const y = 50 + Math.sin(index / 3.2) * 14 + Math.sin(index / 7.5) * 10;

  return `${index === 0 ? "M" : "L"} ${x.toFixed(2)} ${y.toFixed(2)}`;
}).join(" ");

export const LinearChartSkeleton: FC = () => {
  return (
    <Styled.Root>
      <Styled.Watermark aria-hidden>
        <LogoSvg style={Styled.watermarkSvgStyle} />
      </Styled.Watermark>

      <Styled.ChartArea>
        <Styled.SkeletonPlot viewBox="0 0 100 100" preserveAspectRatio="none">
          <Styled.SkeletonLine d={WAVE_PATH} />
        </Styled.SkeletonPlot>
      </Styled.ChartArea>
    </Styled.Root>
  );
};
